





import {Component, Prop, Vue} from "vue-property-decorator";
import {ComplaintStatus} from "@/enums/status";
import {IdMapper} from "@/interfaces/state/base";

    @Component({
        name: "ComplaintStatusLabel"
    })
    export default class extends Vue {
        @Prop({ required: true})
        readonly  status!: number;
        ComplaintStatus = ComplaintStatus;
        colorMap: IdMapper<string> = {
            [ComplaintStatus.ChuaXuLy]: "red",
            [ComplaintStatus.DaXuLy]: "green",

        }
    }
